document.addEventListener("keydown", function (e) {
  /*
      CTRL + K : Focus on the user search
  */
  if(e.ctrlKey && e.key == "k") {
    document.querySelector('#general-search input[type="text"]').focus();
    e.preventDefault();
  }
});
